import React, {Component} from 'react';
import {connect} from "react-redux";
import Objects from "../../redux/Objects";
import {history} from "../../history/History";
import Loading from "../shared/Loading";
import {show} from "../../utils/Toast";
import InputMaterial from "../shared/InputMaterial";
import {addToMyFavorite, sendFeedback} from "../../utils/API";
import Checkbox from "../utils/Checkbox";

class Score extends Component {

    constructor(props) {
        super(props);

        this.state = {
            feedback: '',
            score: 0,
            lastScore: 0,
            addFavorite: false
        }
    }

    componentDidMount() {
        if (!this.props.currentTask) {
            history.push("/hom")
        }
    }

    sendFeedback = () => {
        if (this.state.score === 0) {
            show("choose score")
            return
        }
        this.setState({
            sendFeedbackApi: true
        })
        sendFeedback(this.props.currentTask.hashId, this.state.score, this.state.feedback, () => {
            if (this.state.addFavorite)
                addToMyFavorite(this.props.currentTask.tutor.hashId, () => {
                    show("Tutor was added to favorites")
                    history.goBack()
                }, () => {
                    history.goBack()
                })
            else {
                show("Tutor was added to favorites")
                history.goBack()
            }
            show("Your score was submitted")
        }, () => {

            this.setState({
                sendFeedbackApi: false
            })
        })
    }

    setFeedback(evt) {
        evt.preventDefault();
        if (evt.target.value.length === 768)
            return
        this.setState({
            feedback: evt.target.value,
        })
    }

    onMouseEnterScore = (score) => {
        this.setState({
            score: score,
            lastScore: this.state.score
        })
    }
    onMouseLeaveScore = (score) => {
        this.setState({
            score: this.state.lastScore,
        })
    }
    onSetScore = (score) => {
        this.setState({
            score: score,
            lastScore: score
        })
    }

    getClassStar = (score) => {
        return score > this.state.score ? "white-text icon-star-empty s2-x" : "white-text icon-star-full s2-x";
    }

    render() {
        return (
            <div className="contain-app">
                {this.props.currentTask && <div>
                    <div className=" pt-4 mb-1 text-center">
                        <img className="score-img"
                             alt=""
                             src={window.baseFile + this.props.currentTask.tutor.profilePhotoUrl}/>
                    </div>
                    <div className="title-login pt-3 bold">
                        <h4>{'@ ' + this.props.currentTask.tutor.username}</h4>
                    </div>
                    <div className="body-login">
                        <div>
                            <div className="mt-3 d-flex flex-row justify-content-between">
                                <button onMouseEnter={() => this.onMouseEnterScore(1)}
                                        onMouseLeave={() => this.onMouseLeaveScore(1)}
                                        onClick={() => this.onSetScore(1)}>
                                    <i className={this.getClassStar(1)}/>
                                </button>
                                <button onMouseEnter={() => this.onMouseEnterScore(2)}
                                        onMouseLeave={() => this.onMouseLeaveScore(2)}
                                        onClick={() => this.onSetScore(2)}>
                                    <i className={this.getClassStar(2)}/>
                                </button>
                                <button onMouseEnter={() => this.onMouseEnterScore(3)}
                                        onMouseLeave={() => this.onMouseLeaveScore(3)}
                                        onClick={() => this.onSetScore(3)}>
                                    <i className={this.getClassStar(3)}/>
                                </button>
                                <button onMouseEnter={() => this.onMouseEnterScore(4)}
                                        onMouseLeave={() => this.onMouseLeaveScore(4)}
                                        onClick={() => this.onSetScore(4)}>
                                    <i className={this.getClassStar(4)}/>
                                </button>
                                <button onMouseEnter={() => this.onMouseEnterScore(5)}
                                        onMouseLeave={() => this.onMouseLeaveScore(5)}
                                        onClick={() => this.onSetScore(5)}>
                                    <i className={this.getClassStar(5)}/>
                                </button>
                            </div>
                            <div className="text-left mt-4">
                                <h5>Feedback (optional)</h5>
                            </div>
                            <InputMaterial id="Feedback"
                                           multiLine={true}
                                           type="text"
                                           value={this.state.feedback}
                                           title="Feedback"
                                           onChange={(evt) => this.setFeedback(evt)}
                            />
                            <div>
                                <Checkbox checked={this.state.addFavorite}
                                          onChange={() => this.setState({addFavorite: !this.state.addFavorite})}
                                          label={'Add tutor to my favorite list'}/>
                            </div>
                            <button
                                className="waves-effect waves-light mt-5 btn-large white w-100 no-uppercase bold"
                                disabled={this.state.sendFeedbackApi || this.state.score === 0}
                                onClick={this.sendFeedback}>
                                <Loading show={this.state.sendFeedbackApi}>
                                    <span>Confirm</span>
                                </Loading>
                            </button>
                        </div>
                    </div>
                </div>}
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch: dispatch
    }
}

const mapStateToProps = (state) => {
    return {
        profile: state.param[Objects.profile],
        currentTask: state.param[Objects.currentTask],
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Score)
